<template>
  <div>
    <el-container>
      <el-header>
        <el-row type="flex" class="row-bg" justify="center">
          <el-dropdown trigger="click" @command="switchStation">
            <div style="color: rgb(191, 203, 217);font-weight: bold;font-size: large;line-height: 60px;">
              {{stationName}}
              <i class="el-icon-arrow-down el-icon--right"></i>
              <el-dropdown-menu class="station_dropdown" slot="dropdown">
                <el-row>
                  <div>
                    <el-input
                      v-model="stationNameSelectInput"
                      placeholder="请输入充电站">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </div>
                </el-row>
                <el-dropdown-item >
                  全 部
                </el-dropdown-item>
                <el-dropdown-item v-for="site in stationsForSelectTemp" :key="site.id" :command="site.stationCode">
                  {{site.stationName}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </div>
          </el-dropdown>

        </el-row>
      </el-header>
      <el-main>
        <div class="div_two">
          <el-row>
            <el-col :span="5">
              <el-row class="chargestate">
                <el-col>
                  <el-progress type="circle" :percentage="utilization" :stroke-width="8"></el-progress>
                  <h5>月利用率</h5>
                </el-col>
                <!--<div>-->
                <!--&lt;!&ndash;<h5>充电站概况</h5>&ndash;&gt;-->
                <!--<el-tag type="danger">快充：</el-tag>-->
                <!--<el-tag type="success">慢充：</el-tag>-->
                <!--</div>-->
              </el-row>
            </el-col>
            <el-col :span="14">
              <div>
                <!--<h5 class="h5_style">充电桩 ()</h5>-->
                <div>
                  <!--<el-row>-->
                  <!--<div class="div_style_one div_bule">-->
                  <!--<div class="fontStyle_three">-->
                  <!--<div class="fontStyle_one ">空闲</div>-->
                  <!--<div class="fontStyle_two">0</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="div_style_one div_bule">-->
                  <!--<div class="fontStyle_three">-->
                  <!--<div class="fontStyle_one">充电</div>-->
                  <!--<div class="fontStyle_two">0</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="div_style_one div_bule">-->
                  <!--<div class="fontStyle_three">-->
                  <!--<div class="fontStyle_one">离线</div>-->
                  <!--<div class="fontStyle_two">0</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="div_style_one div_bule">-->
                  <!--<div class="fontStyle_three">-->
                  <!--<div class="fontStyle_one">服务异常</div>-->
                  <!--<div class="fontStyle_two">0</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--</el-row>-->
                  <h5 class="h5_style">充电枪运行状态</h5>
                  <el-row>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">总枪数/个</div>
                        <div class="fontStyle_two">{{stationGunHour.totalGunNum}}</div>
                      </div>
                    </div>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">充电中/个</div>
                        <div class="fontStyle_two">{{stationGunHour.chargingGunNum}}</div>
                      </div>
                    </div>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">空闲/个</div>
                        <div class="fontStyle_two">{{stationGunHour.freeGunNum}}</div>
                      </div>
                    </div>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">离线/个</div>
                        <div class="fontStyle_two">{{stationGunHour.offlineGunNum}}</div>
                      </div>
                    </div>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three" >
                        <div class="fontStyle_one">故障/个</div>
                        <div class="fontStyle_two">{{stationGunHour.badGunNum}}</div>
                      </div>
                    </div>
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <el-row class="chargestate">
                <el-col>
                  <el-progress type="circle" :percentage="onlineRate" :stroke-width="8"></el-progress>
                  <h5>实时在线率</h5>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>

        <el-row :gutter="14">
          <el-col :span="12">
            <div class="div_two div_margin">
              <div style="margin-left: 20px;">
                <h5 class="h5_style">当日</h5>
                <el-row>
                  <div class="div_style_one div_Orange">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one ">充电量(kW·h)</div>
                      <div class="fontStyle_two">{{currentDayOrder.totalElectricity}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_Orange">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电收入(元)</div>
                      <div class="fontStyle_two">{{currentDayOrder.totalFee}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_Orange">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">服务费(元)</div>
                      <div class="fontStyle_two">{{currentDayOrder.serviceFee}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_Orange">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电订单(笔)</div>
                      <div class="fontStyle_two">{{currentDayOrder.orderNum}}</div>
                    </div>
                  </div>
                </el-row>
                <h5 class="h5_style">当月</h5>
                <el-row>
                  <div class="div_style_one div_red">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电量(kW·h)</div>
                      <div class="fontStyle_two">{{currentMonthOrder.totalElectricity}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_red">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电收入(元)</div>
                      <div class="fontStyle_two">{{currentMonthOrder.totalFee}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_red">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">服务费(元)</div>
                      <div class="fontStyle_two">{{currentMonthOrder.serviceFee}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_red">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电订单(笔)</div>
                      <div class="fontStyle_two">{{currentMonthOrder.orderNum}}</div>
                    </div>
                  </div>
                </el-row>
                <h5 class="h5_style">当年</h5>
                <el-row>
                  <div class="div_style_one div_bule">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one ">充电量(kW·h)</div>
                      <div class="fontStyle_two">{{currentYearOrder.totalElectricity}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_bule">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电收入(元)</div>
                      <div class="fontStyle_two">{{currentYearOrder.totalFee}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_bule">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">服务费(元)</div>
                      <div class="fontStyle_two">{{currentYearOrder.serviceFee}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_bule">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电订单(笔)</div>
                      <div class="fontStyle_two">{{currentYearOrder.orderNum}}</div>
                    </div>
                  </div>
                </el-row>
                <h5 class="h5_style">累计</h5>
                <el-row>
                  <div class="div_style_one div_green">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电量(kW·h)</div>
                      <div class="fontStyle_two">{{totalOrder.totalElectricity}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_green">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电收入(元)</div>
                      <div class="fontStyle_two">{{totalOrder.totalFee}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_green">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">服务费(元)</div>
                      <div class="fontStyle_two">{{totalOrder.serviceFee}}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_green">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">充电订单(笔)</div>
                      <div class="fontStyle_two">{{totalOrder.orderNum}}</div>
                    </div>
                  </div>
                </el-row>
              </div>
            </div>
            <!--<el-row :gutter="14"><el-col :span="24"><div class="div_two div_margin"></div></el-col></el-row>-->
          </el-col>

          <!--尖峰平谷-->
          <el-col :span="12">
            <div class="div_two">
              <div class="st-gbox" style="height: 35vh;">
                <div class="cavasbox" id="IncomeEchart"></div>
              </div>
            </div>

            <!--收入曲线分布图-->
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <div class="st-gbox" style="height: 35vh;">
                    <div class="cavasbox" id="ChargeIncomeEchart"></div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>

        </el-row>

        <!--<el-row :gutter="44">
          <el-col :span="24">
            <div class="div_two div_margin">
              <h3 class="h5_style">充电站收入分布图</h3>
              <div class="st-gbox">
                <div class="cavasbox" id="StationEchart"></div>
              </div>
            </div>
          </el-col>
        </el-row>-->

        <!--营业额/充电量-->
        <el-row :gutter="14">
          <el-col :span="24">
            <div class="div_two div_margin">
              <h5 class="h5_style">营业额(元)/充电量(kW·h)</h5>
              <div class="st-gbox" style="height: 45vh;">
                <div class="cavasbox" id="PersonalEchart"></div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px;">
          <h5 class="h5_style">枪每天充电统计</h5>
          <el-table :data="table.views" highlight-current-row v-loading="table.loading" border
                    element-loading-text="拼命加载中"
                    style="width: 100%;">
            <af-table-column prop="stationName" label="站点名称"></af-table-column>
            <af-table-column prop="pileCode" label="桩编号"></af-table-column>
            <af-table-column prop="gunCode" label="枪编号"></af-table-column>
            <af-table-column prop="totalElectricQuantity" label="总电量(kW·h)"></af-table-column>
            <af-table-column prop="totalChargeTime" label="充电时长(分:秒)"></af-table-column>
            <af-table-column prop="totalFee" label="总费用(元)"></af-table-column>
            <af-table-column prop="totalElectricFee" label="电费(元)"></af-table-column>
            <af-table-column prop="totalServiceFee" label="服务费(元)"></af-table-column>
            <af-table-column prop="usedRate" label="使用率(%)"></af-table-column>
            <af-table-column prop="batchTime" label="时间"></af-table-column>
          </el-table>
          <!-- 分页组件 add by shikai-->
          <Pagination v-bind:child-msg="table.pageparm" @callFather="changePage"></Pagination>
        </el-row>

      </el-main>
    </el-container>
  </div>
</template>

<script type="text/ecmascript-6">
  import Pagination from '../../../components/Pagination'
  import Chart from 'echarts'
  import siteMonitorApi from '../../operatingCenter/api/siteMonitorApi'

  export default {
    name: 'siteMonitor',
    data() {
      return {
        currentDayOrder: {},
        currentMonthOrder: {},
        currentYearOrder: {},
        totalOrder: {},
        dailyOrderList: {},
        dailyStationGroupList:{},
        dailyStationOrderList: {},
        stationGunHour:{},
        pileOrdeMonthly:[],
        utilization:0,
        onlineRate:0,
        stationsForSelect: [],
        stationsForSelectTemp: [],
        stationName: "全 部",
        stationNameSelectInput: '',
        table: {
          loading: false,
          views: [],
          pageparm: { // 分页参数
            t: {
              stationCode: '',
            },
            currentPage: 1,
            pageSize: 10,
            total: 0
          },
        },
      }
    },
    // 里面的函数只有调用才会执行
    methods: {
      getChargeIncome() {
        let dayData = []
        let dayTotalElectricity = []
        let dayTotalFee = []
        let dayTotalElectricFee = []
        let dayServiceFee = []
        let dayOrderNum = []
        for (let index in this.dailyStationOrderList) {
          dayData[index] = this.dailyStationOrderList[index].batchTime;
          dayTotalElectricity[index] = this.dailyStationOrderList[index].totalElectricQuantity;
          dayTotalFee[index] = this.dailyStationOrderList[index].totalFee;
          dayTotalElectricFee[index] = this.dailyStationOrderList[index].totalElectricFee;
          dayServiceFee[index] = this.dailyStationOrderList[index].totalServiceFee;
          dayOrderNum[index] = this.dailyStationOrderList[index].totalOrderNumber
        }
        this.chart = Chart.init(document.getElementById("ChargeIncomeEchart"));
        this.chart.setOption({

          title: {
            text: '充电分布/天'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['充电电量', '营业额', '电费','服务费', '订单数量'],
            top: 1,
            left: 200,
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 12
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              interval: 0,
              rotate:30
            },
            data: dayData
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '充电电量',
              type: 'line',
              stack: '总量',
              data: dayTotalElectricity
            },
            {
              name: '营业额',
              type: 'line',
              stack: '总量',
              data: dayTotalFee
            },
            {
              name: '电费',
              type: 'line',
              stack: '总量',
              data: dayTotalElectricFee
            },
            {
              name: '服务费',
              type: 'line',
              stack: '总量',
              data: dayServiceFee
            },
            {
              name: '订单数量',
              type: 'line',
              stack: '总量',
              data: dayOrderNum
            }
          ]
        })
      },
      //尖峰平谷
      getIncomeEchart() {
        let totalSharpElectricity = this.currentMonthOrder.totalSharpElectricity
        let totalPeakElectricity = this.currentMonthOrder.totalPeakElectricity
        let totalFlatElectricity = this.currentMonthOrder.totalFlatElectricity
        let totalValleyElectricity = this.currentMonthOrder.totalValleyElectricity
        let totalSharpFee = this.currentMonthOrder.totalSharpFee
        let totalPeakFee = this.currentMonthOrder.totalPeakFee
        let totalFlatFee = this.currentMonthOrder.totalFlatFee
        let totalValleyFee = this.currentMonthOrder.totalValleyFee

        this.chart = Chart.init(document.getElementById("IncomeEchart"))
        this.chart.setOption({
          title: {
            text: '当月统计',
          },
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            orient: 'vertical',
            x: 'left',
            top: '13%',
            data: ['尖', '峰', '平', '谷']
          },
          series: [
            {
              name: '充电收入',
              type: 'pie',
              selectedMode: 'single',
              radius: [0, '30%'],

              label: {
                normal: {
                  position: 'inner'
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [
                {value: totalSharpFee, name: '尖', selected: true},
                {value: totalPeakFee, name: '峰'},
                {value: totalFlatFee, name: '平'},
                {value: totalValleyFee, name: '谷'}
              ]
            },
            {
              name: '充电电量',
              type: 'pie',
              radius: ['40%', '55%'],
              label: {
                normal: {
                  formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                  backgroundColor: '#eee',
                  borderColor: '#aaa',
                  borderWidth: 1,
                  borderRadius: 4,
                  // shadowBlur:3,
                  // shadowOffsetX: 2,
                  // shadowOffsetY: 2,
                  // shadowColor: '#999',
                  // padding: [0, 7],
                  rich: {
                    a: {
                      color: '#999',
                      lineHeight: 22,
                      align: 'center'
                    },
                    // abg: {
                    //     backgroundColor: '#333',
                    //     width: '100%',
                    //     align: 'right',
                    //     height: 22,
                    //     borderRadius: [4, 4, 0, 0]
                    // },
                    hr: {
                      borderColor: '#aaa',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0
                    },
                    b: {
                      fontSize: 16,
                      lineHeight: 33
                    },
                    per: {
                      color: '#eee',
                      backgroundColor: '#334455',
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              },
              data: [
                {value: totalSharpElectricity, name: '尖'},
                {value: totalPeakElectricity, name: '峰'},
                {value: totalFlatElectricity, name: '平'},
                {value: totalValleyElectricity, name: '谷'}

              ]
            }
          ]
        })
      },
      // 电站的收入/电量柱状图
      /*getPileOrder () {
        let pileOrder = this.pileOrdeMonthly
        let yDate = []
        let electricityDate = []
        let feeDate = []
        for (let i=0;i<pileOrder.length;i++) {
          yDate[i] = pileOrder[i].pileCode
          electricityDate[i] = pileOrder[i].totalElectricity
          feeDate[i] = pileOrder[i].totalFee
        }
        console.log(yDate)
        this.chart = Chart.init(document.getElementById("StationEchart"))
        this.chart.setOption({
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: ['收入', '充电量']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis:  {
            type: 'value'
          },
          yAxis: {
            type: 'category',
            data: yDate
          },
          series: [
            {
              name: '收入',
              type: 'bar',
              stack: '总量',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: feeDate
            },
            {
              name: '充电量',
              type: 'bar',
              stack: '总量',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: electricityDate
            }
          ]
        })
      },*/
      getPersonal() {
        let dayData = []
        let totalElectricityGroup = []
        let totalFeeGroup = []
        let totalFeeCustomer = []
        let totalElectricityCustomer = []
        for (let index in this.dailyStationGroupList) {
          dayData[index] = this.dailyStationGroupList[index].batchTime;
          totalElectricityGroup[index] = this.dailyStationGroupList[index].groupElectricQuantity;
          totalFeeGroup[index] = this.dailyStationGroupList[index].groupFee;
          totalElectricityCustomer[index] = this.dailyStationGroupList[index].stationElectricQuantity;
          totalFeeCustomer[index] = this.dailyStationGroupList[index].stationFee;
        }
        this.chart = Chart.init(document.getElementById("PersonalEchart"));
        this.chart.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: ['总营业额', '总充电量', '集团营业额', '集团充电量']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },

          xAxis: [{
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#90979c'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate:30
            },
            data: dayData
          }],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '总营业额',
              type: 'bar',
              stack: '总营业额',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: totalFeeCustomer
            },
            {
              name: '总充电量',
              type: 'bar',
              stack: '总充电量',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: totalElectricityCustomer
            },
            {
              name: '集团营业额',
              type: 'bar',
              stack: '集团营业额',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: totalFeeGroup
            },
            {
              name: '集团充电量',
              type: 'bar',
              stack: '集团充电量',
              label: {
                normal: {
                  show: false,
                  position: 'insideRight'
                }
              },
              data: totalElectricityGroup
            }
          ]
        })
      },
      // 加载下拉框
      loadSelectItem() {
        siteMonitorApi.getStations(this.$store.getters.operatorIds).then((res) => {
          if (res.code == 0)
            this.stationsForSelect = res.data
          this.stationsForSelectTemp = res.data.slice(0)
        })
      },
      async switchStation(command, event) {
        await this.getStationGun(command);
        this.getStationOrder(command);
        this.getDailyGunStatistics(command)
        this.stationName = event.$el.innerText
      },
      changePage() {//查询表格分页
        this.getDailyGunStatistics();
      },
      getDailyGunStatistics(param) {
        this.table.listLoading = true;
        if (param) {
          this.table.pageparm.t.stationCode = param;
        }
        let json = JSON.stringify(this.table.pageparm);
        siteMonitorApi.getDailyGunStatistics(json).then((res) => {
          console.log(res);
          if (res.code === 0) {
            console.log('getDailyGunStatistics::', res);
            for (let i in res.data.list) {
              let minute = (res.data.list[i].totalChargeTime / 60) ;
              let second = (res.data.list[i].totalChargeTime % 60) ;
              let totalChargeTime = parseInt(minute) + ":" + second;
              res.data.list[i].totalChargeTime = totalChargeTime;
            }
            this.table.views = res.data.list;
            this.table.pageparm.total = res.data.total;
          }
          this.table.loading = false;
        })
      },
      getStationOrder(param) {
        siteMonitorApi.getStationOrder(param).then((res) => {
          if (res) {
            this.currentDayOrder = res.currentDayOrder
            this.currentMonthOrder = res.currentMonthOrder
            this.currentYearOrder = res.currentYearOrder
            this.totalOrder = res.totalOrder
            this.dailyOrderList = res.dailyOrderList
            this.dailyStationGroupList = res.dailyStationGroupList
            this.dailyStationOrderList = res.dailyStationOrderList
            //this.pileOrdeMonthly = res.pileOrdeMonthly
            this.utilization = Math.round(res.userRate /(this.stationGunHour.chargingGunNum+this.stationGunHour.freeGunNum)* 100)/100
          } else {
          }
        })
      },
      getStationGun(param) {
        siteMonitorApi.getStationGun(param).then((res)=>{
          if (res) {
            this.stationGunHour = res.stationGunHour
            //this.utilization = res.utilization
            this.onlineRate = res.onlineRate
          } else {
            this.$message.error('服务器开小差了！请重新加载')
          }
        })
      }
    },
    // 导入组件
    components: {
      Pagination
    },
    // 创建完毕状态(里面是操作)
    created() {
    },
    // 挂载结束状态(里面是操作)
    watch: {
      stationNameSelectInput: function (val, oldVal) {
        if (val.length <= 0) {
          this.stationsForSelectTemp = this.stationsForSelect.slice(0,10)
        } else {
          this.stationsForSelectTemp = []
          this.stationsForSelect.forEach((item, index) => {
            if (item.stationName.indexOf(val) >= 0) {
              if (this.stationsForSelectTemp.length<10){
                this.stationsForSelectTemp.push(item)
              }
            }
          })
        }
      }
    },
    async mounted() {
      this.loadSelectItem()
      await this.getStationGun()
      this.getStationOrder()
      this.getDailyGunStatistics()
    },
    beforeUpdate() {
      this.getChargeIncome()
      this.getIncomeEchart()
      this.getPersonal()
      //this.getPileOrder()
    }
  }
</script>

<style scoped>
  .div_margin {
    margin-top: 20px;
    padding-bottom: 10px;
  }

  .div_two {
    background-color: white;
  }

  .h5_style {
    text-align: left;
    margin: 0px 0px 10px 5px;
    padding-top: 10px;
  }

  .div_style_one {
    float: left;
    width: 24%;
    height: 85px;
    margin: 0px 5px 5px 0px
  }

  .div_style_zero {
    float: left;
    width: 18%;
    height: 60px;
    margin: 0px 10px 10px 0px
  }

  .div_Orange {
    background-color: #ffbc2e;
  }

  .div_red {
    background-color: #FF6640;
  }

  .div_bule {
    background-color: #409EFF;
  }

  .div_green {
    background-color: #43c26e;
  }

  .fontStyle_three {
    margin: 10px 20px 0px 20px;
  }

  .fontStyle_one {
    color: white;
    font-size: small;
  }

  .fontStyle_two {
    color: white;
    font-size: 16px;
    margin-top: 5px;
  }

  .fontStyle_four {
    font-size: small;
  }

  .fontStyle_five {
    font-size: 20px;
    margin-top: 5px;
  }

  .el-header {
    color: #C0C4CC;
    text-align: center;
    line-height: 20px;
    background-color: #08263a;
  }

  .el-main {
    background-color: #f0f9eb;
    color: #333;
    text-align: center;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .chargestate {
    padding-top: -120px;
  }

  .st-gbox {
    /*background-color: #fff;*/
    margin-top: 20px;
    border-radius: 5px;
    height: 30vh;
    box-sizing: border-box;
    padding: 10px;
  }

  .cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  /*.el-row {*/
  /*margin-bottom: 4px;*/
  /*&:last-child {*/
  /*margin-bottom: 0;*/
  /*}*/
  /*}*/
  .grid-content {
    border-radius: 2px;
    min-height: 28px;
    line-height: 28px;
    text-align: left;
    font-size: small;
    color: #606266;
    padding-left: 10px;
  }

  /deep/ .el-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }

  .station_dropdown {
    max-height:450px;
    overflow: auto;
  }

</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/siteMonitor.vue